export default "__VITE_ASSET__124f3ef3__"